const MINUTE_MS = 60 * 1000;
export const IDLE_STEP_MS = 5 * MINUTE_MS;
export const MAX_POLL_DELAY_MS = 15 * MINUTE_MS;

// A tab left open on a machine nobody is using would otherwise poll at full rate for days.
export function pollDelay(baseMs: number, { idleMs = 0, failures = 0 } = {}): number {
  const doublings = Math.max(Math.floor(idleMs / IDLE_STEP_MS), failures);
  return Math.min(baseMs * 2 ** doublings, MAX_POLL_DELAY_MS);
}
